// extracted by mini-css-extract-plugin
module.exports = {"root":"_4f720283bf--root--D9TNX","heading":"_4f720283bf--heading--dlh7U"};